import { Star } from 'lucide-react';

type Props = { value: number | null; onChange?: (value: number | null) => void; small?: boolean };

export function Stars({ value, onChange, small = false }: Props) {
  return (
    <div className={`stars ${small ? 'is-small' : ''}`} aria-label={value ? `별점 ${value}점` : '별점 없음'}>
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          type="button"
          key={star}
          className={value !== null && star <= value ? 'is-active' : ''}
          aria-label={`${star}점`}
          disabled={!onChange}
          onClick={() => onChange?.(value === star ? null : star)}
        >
          <Star size={small ? 14 : 18} fill="currentColor" />
        </button>
      ))}
    </div>
  );
}
